/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Permission {
	None = 0,
	View = 1,
	Update = 2,
	Delete = 3,
}
